var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hasError)?_c('span',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm.display)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }